import _ from 'lodash';
import multiLangHelpers from 'utils/multilanguage/helpers/multilanguage-helpers';
import { setServerTime } from 'auth/actions/session.actions';
import { fetchConfigRequest, fetchConfigSuccess, fetchConfigFailure } from '../actions/app.actions';

const CONTEXT = 'app';
const MAINTENANCE_CODE = 'SYSTEM_UNAVAILABLE';

function initializeModel(deps, model) {
  return Object.assign(model);
}

async function loadFeConfig(deps) {
  try {
    const urlParams = {};
    const queryParams = {};
    const path = 'config.frontend';
    const { url } = deps.restApi.config.frontend;

    deps.$ngRedux.dispatch(fetchConfigRequest());

    const config = await deps.restSrv.list(CONTEXT, url, queryParams, urlParams, path);

    deps.$ngRedux.dispatch(fetchConfigSuccess(config));
    return config;
  } catch (error) {
    console.error('FETCH_CONFIG', error);
    deps.$ngRedux.dispatch(fetchConfigFailure());
  }
}

function loadDictionaries(deps, model) {
  return Promise.all([loadWeekdays(deps, model)]).then((models) => models.reduce((reduced, newModel) => _.merge(reduced, newModel), model));
}

function loadWeekdays(deps, model) {
  return Promise.resolve(model);
}

function loadJurisdictionData(deps, model) {
  return deps.restSrv
    .list(undefined, model.session.rest.jurisdiction.details.url, null, null, null, 'jurisdiction.details')
    .then((results) => {
      deps.$ngRedux.dispatch(
        setServerTime(results.serverTime, (results.serverTimezoneDiff = 0), results.lotteryTimezoneDiff, results.salesPeriodTime)
      );
      return Promise.resolve(model);
    });
}

function toggleEditMode(deps, model, namespace, module) {
  const pathToEditMode = `${namespace}.${module}.editMode`;
  const editMode = _.get(model, pathToEditMode);

  return _.set(model, pathToEditMode, !editMode);
}

function toggleLanguageSelect(deps, model, namespace, module, language) {
  const newModel = _.set(model, `${namespace}.${module}.language`, language);
  return Promise.resolve(newModel);
}

function initializeForm(deps, model, namespace, module, form, createForm = false) {
  const { config } = deps.$ngRedux.getState();
  const { locales } = config;

  if (!_.get(model, `${namespace}.${module}.languageValidation`)) {
    model[namespace][module].languageValidation = {};
  }
  locales.map((locale) => {
    Object.assign(model[namespace][module].languageValidation, {
      [locale.code]: !createForm,
    });
  });
  model = _.set(model, `${namespace}.${module}.form`, form);
  return Promise.resolve(model);
}

function setLanguageValidation(deps, model, namespace, module, valid) {
  model[namespace][module].languageValidation[model[namespace][module].language] = valid;
  return Promise.resolve(model);
}

function getInvalidForms(model, namespace, module) {
  return Object.keys(model[namespace][module].languageValidation).filter(
    (key) => model[namespace][module].languageValidation[key] === false
  );
}

function checkValidation(model, namespace, module) {
  const invalidForms = getInvalidForms(model, namespace, module);
  model[namespace][module].invalid = !!invalidForms.length;
  return Promise.resolve(model);
}

function validateForm(deps, model, namespace, module) {
  const form = _.get(model, `${namespace}.${module}.form`);
  const formIsValid = multiLangHelpers.checkFormValidation(form);
  let retValue;

  setLanguageValidation(deps, model, namespace, module, formIsValid);
  checkValidation(model, namespace, module);

  if (model[namespace][module].invalid) {
    const invalidForms = getInvalidForms(model, namespace, module);
    if (invalidForms.length > 0 && invalidForms.indexOf(model[namespace][module].language) < 0) {
      deps.Notifications.alertWarning(deps.gettextCatalog.getString('Enter other language before submitting.'));
    } else {
      deps.Notifications.alertWarning(deps.gettextCatalog.getString('Validation failed. Please review errors.'));
    }
    retValue = Promise.reject(new Error('VALIDATION_FAILED'));
  } else {
    model = toggleLanguageSelect(deps, model, namespace, module, model.session.locale);
    retValue = Promise.resolve(model);
  }
  return retValue;
}

function checkAndSetMaintenance(err, model, path) {
  if (err === MAINTENANCE_CODE) {
    model = _.set(model, `${path}.isMaintenance`, true);
  }
  return model;
}

export default {
  initializeModel,
  loadDictionaries,
  loadJurisdictionData,
  toggleEditMode,
  loadFeConfig,
  toggleLanguageSelect,
  initializeForm,
  validateForm,
  setLanguageValidation,
  checkAndSetMaintenance,
};



// WEBPACK FOOTER //
// ./src/modules/app/logic/app.js